let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gjVBG")).then(() => parcelRequire('k8Fbb'));